<template>
<div class="form-group" :class="[{ 'coff-input-error' : error }]" :key="uuid">

    <label htmlFor="input">
        <b>{{$t(label)}}</b>
        <slot name="label"></slot>
    </label>

    <div class="input-group">
        <auto-complete style="width: 100%;" :class="[{ 'p-error' : error }]" :id="uuid" :dropdown="dropdown" :multiple="false" :value="value" v-on="listeners"
                      :suggestions="itensFiltered" @complete="filter($event)" :field="field" ref="autocomplete"/>
        <span v-if="error">{{ $t(errorMessage)}}</span>
    </div>

</div>
</template>

<script>
    import Utils from "@/utils/Utils";

    export default {
        name: "CoffInputAutoComplete",

        props:{
            label: {type: String, default: null},
            value: null,
            error: {type: Boolean, default: false},
            errorMessage: {type: String, default: 'field.default.error'},
            id: null,
            field: {type: String, default: null},
            itens: {type: Array, default: () => {return []}},
            funcSuggestions: {type: Function, default: async (val) => {return[val]}},
            filterFuncSuggestions: {type: Boolean, default: true},
            dropdown: {type: Boolean, default: false},
            debounceTime: {type: Number, default: 500},
        },

        watch: {
          value(){
            if(!Utils.isEmptyNullOrUndefined(this.value) && !(this.value instanceof Object) && this.filterFuncSuggestions){
              this.debounceSearch();
            }
          }
        },

        data(){
            return {
                uuid: Utils.uuid(),
                localItens: [...this.itens],
                itensFiltered: [...this.itens],
                debounceSearch: Utils.debounce(this.search, this.debounceTime),
            }
        },

        mounted() {
            if(this.id){
                this.uuid = this.id;
            }
        },
        computed: {
            listeners() {
                return {
                    ...this.$listeners,
                    InputText: event => this.$emit('InputText', event.target.value)
                };
            },
        },
        methods: {
            filter(event) {
                if (!event.query.trim().length) {
                    this.itensFiltered = [...this.localItens]
                } else {
                    if (this.field) {
                        this.itensFiltered = this.localItens.filter(item => {
                            item[this.field].toLowerCase().startsWith(event.query.toLowerCase());
                        });
                    } else {
                        this.itensFiltered = this.localItens.filter(item => {
                            item.toLowerCase().startsWith(event.query.toLowerCase());
                        });
                    }
                }
            },

            async search(){
              this.localItens = await this.funcSuggestions(this.value);
              this.$refs.autocomplete.onDropdownClick();
            }
        }
    }
</script>

<style scoped>

</style>
